import React, { useEffect, useState } from 'react';
import BaseModal from '../baseModal';
import axios from 'axios';
import { FormControl, FormHelperText, InputBase, InputLabel, MenuItem, NativeSelect, Select, TextField } from '@mui/material';
import { stacksApi } from '../../lib/constants';
import { styled } from '@mui/material/styles';

const ExtensionModal = ({ show, close, authorPrincipal }) => {
    const [extensions, setExtensions] = useState(['ST2K0XNVRNGWK78Q4MSDZ57WNGZ0Z0TRC2AZ4D34P.derupt-ext']);
    const [selectedExtensions, setSelectedExtensions] = useState('');
    const [args, setArgs] = useState([]);

    async function handleSelectExtension(e) {
        const { value } = e.target;
        if (!value) return;
        setSelectedExtensions(value);
        let res = (await axios.get(`${stacksApi}/v2/contracts/interface/${value.split('.')[0]}/${value.split('.')[1]}`)).data;
        res = res?.functions.filter((options) => options?.access === 'public' && options?.name === 'exec-ext-func')[0]?.args
        res = res[0]?.type?.optional?.list?.type?.tuple;
        setArgs(res);
    }

    // async function getExtensions() {

    // }

    // useEffect(() => {
    //     getContractInterface();
    // }, [])

    useEffect(() => {
        console.log({ args, selectedExtensions });
        console.log(selectedExtensions.toLocaleUpperCase().split('.')[1]);
    }, [args, selectedExtensions])

    const BootstrapInput = styled(InputBase)(({ theme }) => ({
        'label + &': {
            marginTop: theme.spacing(3),
        },
        '& .MuiInputBase-input': {
            borderRadius: 4,
            position: 'relative',
            backgroundColor: theme.palette.background.paper,
            border: '1px solid #ced4da',
            fontSize: 16,
            padding: '10px 26px 10px 12px',
            transition: theme.transitions.create(['border-color', 'box-shadow']),
            // Use the system font instead of the default Roboto font.
            fontFamily: [
                '-apple-system',
                'BlinkMacSystemFont',
                '"Segoe UI"',
                'Roboto',
                '"Helvetica Neue"',
                'Arial',
                'sans-serif',
                '"Apple Color Emoji"',
                '"Segoe UI Emoji"',
                '"Segoe UI Symbol"',
            ].join(','),
            '&:focus': {
                borderRadius: 4,
                borderColor: '#80bdff',
                boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
            },
        },
    }));

    return (
        <BaseModal show={show} handleClose={close}>
            <div className='extension'>
                <FormControl sx={{ m: 1 }} variant="standard" fullWidth>
                    <InputLabel htmlFor="demo-customized-select-native">Extension's</InputLabel>
                    <NativeSelect
                        id="demo-customized-select-native"
                        value={selectedExtensions}
                        onChange={handleSelectExtension}
                        input={<BootstrapInput />}
                    >
                        <option aria-label="None" value="">Select Extension</option>
                        {extensions.length > 0 && extensions.map((extensionContract, i) => (
                            <option value={extensionContract} key={i}>{extensionContract.split('.')[1].toLocaleUpperCase().replace('-', ' ')}</option>
                        ))}
                    </NativeSelect>
                </FormControl>

                <div className='function-input-box'>
                    {args.length > 0 && args.map((values, i) => (
                        <TextField fullWidth label={values?.name} value={values?.name === "principal" ? authorPrincipal : ''} id="fullWidth" key={i} />
                    ))}
                </div>
            </div>
        </BaseModal>
    );
};

export default ExtensionModal;